import React from 'react';
import { ReactComponent as CloseButtonSvg } from 'assets/images/location/close-button-svg.svg';
import PropTypes from 'prop-types';
import cn from 'utils/classnames';

const AppCloseModalButton = ({ onClick, className }) => (
  <button
    className={cn('reset-button', className)}
    onClick={onClick}
    type="button"
  >
    <CloseButtonSvg />
  </button>
);

export default AppCloseModalButton;

AppCloseModalButton.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
};

AppCloseModalButton.defaultProps = {
  onClick: () => { },
  className: '',
};
